import { render, staticRenderFns } from "./WorkOrderAssign.vue?vue&type=template&id=1f34bec8&scoped=true&"
import script from "./WorkOrderAssign.vue?vue&type=script&lang=ts&"
export * from "./WorkOrderAssign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34bec8",
  null
  
)

export default component.exports